import React, { useEffect } from "react";
import FoodItem from "./foodItem";
import { OrderMenuContainer } from "../styled/pickup";
import { useMediaQuery } from "react-responsive";

const OrderMenu = ({ selected, products = [] }) => {
  const getOptionTotalForItem = (item) => {
    const options = item?.options || [];
    const perUnitOption = options.reduce(
      (sum, opt) => sum + (opt?.optionPrice || 0) * (opt?.quantity || 1),
      0,
    );
    return perUnitOption * (item?.quantity || 1);
  };

  const getGrandTotal = () => {
    return products.reduce(
      (acc, item) => acc + (item?.price || 0) + getOptionTotalForItem(item),
      0,
    );
  };

  console.log(selected);

  return (
    <OrderMenuContainer className={selected?.status}>
      <div className="info">
        <span className="foodItem label">메뉴</span>
        <span className="foodQuantity">수량</span>
        <span className="foodPrice">금액</span>
      </div>
      <ul>
        {products.map((item) => (
          <FoodItem
            productImgSrc={item.productImgSrc}
            title={item.productName}
            quantity={item.quantity}
            price={item.price}
            options={item.options}
          />
        ))}
        <li className="food">
          <div className="foodItem">
            <span className="tit">합계{` `}</span>
          </div>
          <span className="foodQuantity">
            {products.reduce((acc, item) => acc + item.quantity, 0)}
          </span>
          <span className="foodPrice">{formatNumber(getGrandTotal())}원</span>
        </li>
      </ul>
    </OrderMenuContainer>
  );
};

export default OrderMenu;
